import { MoveEvent, ReactSortable } from 'react-sortablejs';

import {
  SORTABLE_GROUPING_ITEM_CLASS_NAME,
  SORTABLE_GROUPING_SECTION_CLASS_NAME,
} from '../../utils/constants';

import { TableCustomizationGroupedList } from './TableCustomizationGrouped';
import { TableCustomizationItem } from './TableCustomizationItem';
import { TableColumnSettings } from './TableCustomizationModal';

import styles from './table-customization.module.scss';

type TableCustomizationSortableProps = {
  value: TableColumnSettings[];
  onChange: (newValue: TableColumnSettings[]) => void;
  onGroupByClick?: (id: string) => void;
  isGroupingEnabled?: boolean;
  isGroupingSectionLocked?: boolean;
};
export function TableCustomizationSortable({
  value,
  onChange,
  onGroupByClick,
  isGroupingEnabled,
  isGroupingSectionLocked,
}: TableCustomizationSortableProps) {
  const onMove = (evt: MoveEvent) => {
    if (
      evt.to.classList.contains(SORTABLE_GROUPING_SECTION_CLASS_NAME) &&
      (isGroupingSectionLocked ||
        !evt.dragged.classList.contains(SORTABLE_GROUPING_ITEM_CLASS_NAME))
    ) {
      evt.preventDefault();
      return false;
    }
    return true;
  };

  return isGroupingEnabled ? (
    <TableCustomizationGroupedList items={value} onChange={onChange} />
  ) : (
    <ReactSortable
      group="columnCustomization"
      className={styles['sortable']}
      list={value}
      setList={onChange}
      onMove={onMove}
    >
      {value.map((settings) => {
        return (
          <TableCustomizationItem
            {...settings}
            isGroupingSectionLocked={isGroupingSectionLocked}
            key={settings.id}
            onChange={(id, isVisible) => {
              onChange(
                value.map((v) => (id === v.id ? { ...v, isVisible } : v))
              );
            }}
            onGroupByClick={onGroupByClick}
          />
        );
      })}
    </ReactSortable>
  );
}
